<div class="container d-flex flex-column h-100 table-bottom-padding">
  <ziro-breadcrumbs>
    <ziro-breadcrumb-card-item [aboutCardId]="89"></ziro-breadcrumb-card-item>
  </ziro-breadcrumbs>

  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  }
  @if (!isLoading) {
    <ziro-datatable
      [columns]="columns"
      [rowDataSource]="tableRows"
      [dataAutomation]="'migrations-table'"
      [mainFilterPlaceholder]="'tkey;migrations.table.filter.placeholder' | translate"
      [noResultsAlert]="'tkey;migrations.table.no_results' | translate: { tenantId: tenantId }"
      [showCustomAlert]="false"
      [uniqueRowIdentifier]="'name'"
      [resetPageOnDataChange]="false"
      [class]="'ziro-card me-4'"
    ></ziro-datatable>
  }
</div>
